import { supabase } from '@/lib/supabase/config';
import { handleError } from '@/shared/utils/error-handling';

interface AssignProjectPlanInput {
  projectId: number;
  subscriptionId: string;
}

export async function assignProjectPlan(
  input: AssignProjectPlanInput,
): Promise<void> {
  const { error } = await supabase.rpc('assign_project_plan', {
    p_project_id: input.projectId,
    p_subscription_id: input.subscriptionId,
  });

  if (error) {
    const appError = await handleError(error);
    throw appError;
  }
}
